// ARIZORE Official Color Palette

export const colors = {
  // Primary
  graphite: '#404040',
  black: '#000000',
  white: '#FFFFFF',
  
  // Accent
  teal: '#008080',
  
  // AZ Gold Gradient
  goldStart: '#C89820',
  goldMid: '#F2D675',
  goldEnd: '#8C6A03',
  
  // AZ Silver Gradient
  silverStart: '#A09E9E',
  silverMid: '#EDEDED',
  silverEnd: '#7A7A7A',
};

// Helper functions for gradients
export const gradients = {
  gold: `linear-gradient(135deg, ${colors.goldStart} 0%, ${colors.goldMid} 50%, ${colors.goldEnd} 100%)`,
  silver: `linear-gradient(135deg, ${colors.silverStart} 0%, ${colors.silverMid} 50%, ${colors.silverEnd} 100%)`,
  darkHero: `linear-gradient(135deg, ${colors.black} 0%, ${colors.graphite} 100%)`,
};